/**
 * @file signedOutAnswer.ts
 * @brief Whether a failed `GET /api/auth/me` means the user is really signed
 *        out, or the server just could not answer.
 *
 * @details
 * DES 21-10-2026: a backend restart, 5xx, timeout or no network must never
 * sign the user out. Only the server saying so does: 401 (no valid session)
 * or 404 (the account no longer exists). Everything else (status 0 for a
 * network error or timeout, 408, 429, 5xx, a reply we cannot read) keeps the
 * token and reconnects. Pure, so `node --test` can load it.
 *
 * @author DES
 * @date 21-10-2026
 */

export function isSignedOutAnswer(err: unknown): boolean {
  const status = (err as { status?: unknown } | null)?.status;
  return status === 401 || status === 404;
}
